/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CenterUserControllerSetColor$Params {
  centerUserId: string;
  color: string;

/**
 * 센터 ID
 */
  centerId: any;
}

export function centerUserControllerSetColor(http: HttpClient, rootUrl: string, params: CenterUserControllerSetColor$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, centerUserControllerSetColor.PATH, 'patch');
  if (params) {
    rb.path('centerUserId', params.centerUserId, {});
    rb.query('color', params.color, {});
    rb.path('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

centerUserControllerSetColor.PATH = '/api/center-user/{centerId}/users/{centerUserId}/color';
